export const pagesPaths = {
  home: '/myaccess/home',
  proxy: '/myaccess/proxy',
  newRequest: '/myaccess/new-request',
  massiveRequest: '/myaccess/massive-request',
  requestProgress: (id: string) => `/myaccess/request/${id}`,
  approvalDetails: (id: string) => `/myaccess/approval/${id}`,
  workwiseApprovalDetails: (id: string) => `/myaccess/workwise/approval/${id}`,
  workwiseRequestProgress: (id: string) => `/myaccess/workwise/request/${id}`,
  toApprove: '/myaccess/to-approve',
  myAccess: '/myaccess/my-access',
  report: '/myaccess/report',
  guide: '/myaccess/guide'
} as const;

export const pagesEIBPaths = {
  home: '/eib/home',
  proxy: '/eib/proxy',
  newRequest: '/eib/new-request',
  requestProgress: (id: string) => `/eib/request/${id}`,
  approvalDetails: (id: string) => `/eib/approval/${id}`,
  toApprove: '/eib/to-approve',
  myAccess: '/eib/my-access',
  requests: '/eib/requests',
  report: '/eib/report',
  guide: '/eib/guide',
  newRequestStatusPosition: '/eib/new-request-status-position'
} as const;

export type PagesPathsKeys = keyof typeof pagesPaths;
export type PagesEIBPathsKeys = keyof typeof pagesEIBPaths;
